module.exports = __webpack_public_path__ + "img/galeria-agua-dulce-1.02be4a02.jpg";